import { render, staticRenderFns } from "./menu-view.vue?vue&type=template&id=7e08619c&"
import script from "./menu-view.vue?vue&type=script&lang=js&"
export * from "./menu-view.vue?vue&type=script&lang=js&"
import style0 from "./menu-view.vue?vue&type=style&index=0&id=7e08619c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports